import * as React from 'react';
import { useSelector } from 'react-redux';
import { UXFB_CLIENT_EVENTS_CONFIG_KEY, UXFB_EVENT_SEARCH_LISTING } from 'shared/constants/uxfb';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { sendUXSEventWhenReady } from 'shared/utils/uxs';
import { getSearchListingAttributes } from 'shared/utils/uxs/serpEventAttributes';

import { selectJsonQuery } from '../../selectors/results/selectJsonQuery';
import type { IAppState } from '../../common/state';

/**
 * Шлёт UXFB-событие `search_listing` один раз при заходе на выдачу (mount) с атрибутами вертикали/сделки.
 * Применения фильтров покрываются отдельным событием `serp_filter_applied`.
 *
 * `dedupeKey` обязателен: useRef не переживает ремаунт контейнера, дубль события засчитывается
 * бэкендом UXFB как лишний «заход», и кампании «на 2-й заход» выезжают уже на первом.
 */
export function useSearchListingUxfbEvent(): void {
  const { config } = useApplicationContext();
  const jsonQuery = useSelector(selectJsonQuery);
  const deviceType = useSelector((state: IAppState) => state.deviceType);
  const hasSentRef = React.useRef(false);

  React.useEffect(() => {
    if (hasSentRef.current) {
      return;
    }

    if (config.get<boolean>(UXFB_CLIENT_EVENTS_CONFIG_KEY) === false) {
      return;
    }

    hasSentRef.current = true;

    sendUXSEventWhenReady(
      UXFB_EVENT_SEARCH_LISTING,
      getSearchListingAttributes({ jsonQuery, deviceType, viewMode: 'list' }),
      {
        dedupeKey: UXFB_EVENT_SEARCH_LISTING,
      },
    );
  }, [config, jsonQuery, deviceType]);
}
